import React from 'react'
import { HStack, VStack, Box, Image, Text, Button } from '@chakra-ui/react';
import b1 from '../img/book8/8-1.jpg';
import b2 from '../img/book8/8-2.jpg';
import b3 from '../img/book8/8-3.jpg';
import b4 from '../img/book8/8-4.jpg';
import b5 from '../img/book8/8-5.jpg';
import b6 from '../img/book8/8-6.jpg';
import b7 from '../img/book8/8-7.jpg';
import b8 from '../img/book8/8-8.jpg';
import b9 from '../img/book8/8-9.jpg';
import b10 from '../img/book8/8-10.jpg';
import b11 from '../img/book8/8-11.jpg';
import b12 from '../img/book8/8-12.jpg';
const Books8 = () => {
  return (
    <>
    <VStack spacing={4} align="stretch" alignItems={'center'} mt={4}>
      {/* ---------------------book1--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            borderColor="lightgray"
            bg={'#fff'}
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b1} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    اسبح مع أسماك القرش دون أن تفترسك حياً
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    ابتسام الخضراء
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    هارفي ماكاي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b2} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    التعلم الهادف عبر الإنترنت
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    د.مها محمد الفريح
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    ندى دباغ - روز مارا - جين هولاند
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            bg={'#fff'}
            borderRadius="10px"
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b3} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    الحياة قاسية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    مركز الملك فيصل للبحوث والدراسات
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    سليمان جنكيز
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book2--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b4} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    السلوك في الأماكن العامة
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    بيادر النصيان
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                        
                    إرفينغ جوفمان
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار: &nbsp;
                    <span>
                    أثر
                         </span>
                  </Text>
            
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b5} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان: &nbsp;
                    <span>  
                    النظرية والواقع
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                        الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    علي الحارس
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    بيتر كادفري-سميث
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    دار الحكمة
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E21 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b6} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    اليقظة والنوم
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                        الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    هبة الله الغلاييني
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    آنا بلاك
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                        
                    </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book3--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b7} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    حين شاركنا حياتنا عبر الانترنت
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    د. أحمد محمد مصطفى
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    ديفيد أر. بريك
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b8} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    ديانات السياسة
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                        الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    د.سمير المستيري
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    إيميليو دجنتيلي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    دار الحكمة
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E21 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b9} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    سباق السرعة
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    د. أحمد حمدي مصطفى
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    جيك ناب - جون زيراتسكي - برادن كويتز
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    العبيكان
                    </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book4--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b10} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    دعايات مضللة
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    د. عائشة يكن حداد
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    نينا شابيرو - كرستين لوبرغ
                      </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b11} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    فن الشهرة
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    ابتسام الخضراء
                          </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    راينر زيتلمان
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    العبيكان
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                     height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b12} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    لا تغذ عقل القرد
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    ابتسام الخضراء
                      </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    جينيفير شانون
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    العبيكان
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: U27 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
    </VStack>
  </>
  )
}

export default Books8